import { createFileRoute } from '@tanstack/react-router'
import { PublicSurvey } from '../features/satisfaction'

export const Route = createFileRoute('/survey')({
  validateSearch: (raw: Record<string, unknown>): { t: string } => ({ t: typeof raw.t === 'string' ? raw.t.slice(0, 1000) : '' }),
  component: function SurveyRoute() {
    const { t } = Route.useSearch()
    return <PublicSurvey initialToken={t} />
  },
})
